import { useQuery, useMutation, useQueryClient } from "react-query";
import { getLookupsObjective, getObjectiveById, getObjectives, saveObjective, deleteObjective } from "@/api/Maintainers/OA/oa-objective-api.js";

export const key = "objectives";

export function useLookupsObjective(enabled = true) {
	return useQuery([key, "lookups"], () => getLookupsObjective(), { enabled });
}

export function useObjectives(filters, enabled = true) {
	return useQuery([key, "list", filters], () => getObjectives(filters), { enabled });
}

export function useObjectiveById(filters, id_element, enabled) {
	return useQuery([key, "detail", filters, id_element], () => getObjectiveById(filters, id_element), {
		enabled: enabled,
		keepPreviousData: true,
	});
}

export function useSaveObjective() {
	const queryClient = useQueryClient();

	return useMutation(saveObjective, {
		onSuccess: () => {
			queryClient.invalidateQueries([key, "list"]);
		},
	});
}

export function useDeleteObjective() {
	const queryClient = useQueryClient();

	return useMutation(deleteObjective, {
		onSuccess: () => {
			queryClient.invalidateQueries([key, "list"]);
		},
	});
}
